export const eclipseStr = (line, count=40) => {
    return line.length > count ? (line.slice(0, count-3)+'...') : line;
}